export default __webpack_public_path__ + "static/media/group-kitty-icon.8181d86d.png";